import { Box, Button, Divider, FormControl, FormControlLabel, Grid, Radio, RadioGroup, TextField, Typography} from '@mui/material';
import SwitchComponent from '../../../../components/switch';
import { TEXT_TITLE_COLOR } from '../../../../constants/colors';
import SearchProductField from '../../components/searchProductField';
import { MerChantModel } from '../../../../models/merChantModel';
import { useTranslation } from 'react-i18next';
import SelectBranchComponent from '../../components/SelectBranch';
import { TagPromotionModel } from '../../../../models/tagPromotion.model';
import SelectedTagPromotionComponent from '../../components/SelectTagPromotion';
import { PromotionEnumType } from '../../../../enums/promotionEnum';
import useBuyXGetCSTByPricePromotionController from './controller';
import SelectProductComponents from '../../components/SelectProductComponents';
import ListSelectProductComponent from '../../components/ListSelectProduct';
import ConfirmDialog from '../../../../components/ConfirmDialog';
import { PromotionModel } from '../../../../models/promotion';
import { EN_ACCEPT_LANGUAGE } from '../../../../constants/acceptLanguageApi';
import { IMAGE_PRODUCTS_ROOT_URL } from '../../../../constants/imageUrl';
import DateHourPicker from '../../components/DateHourPicker';
import { PromotionTypeEnumPromotion } from '../../../../enums/discountEnum';

interface Props {
  onClose: VoidFunction;
  branchData: MerChantModel[];
  tagPromotionData: TagPromotionModel[];
  promotionType: PromotionEnumType;
  onFetchData: Function;
  selectedData: PromotionModel;
}

const BuyXGetSetAGetCSTByPriceFormComponent = ({onClose, branchData, tagPromotionData, promotionType, onFetchData, selectedData }: Props) => {
  const controller = useBuyXGetCSTByPricePromotionController({ branchData, promotionType, onFetchData, onClose, tagPromotionData, selectedData });
  const { t, i18n } = useTranslation('global');
  return (
    <Box
      sx={{ p: 2, mt: 2, boxShadow: '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)', borderRadius: '10px' }} >
      <Grid container spacing={2}>
        <Grid item xs={4} sm={4} md={4}>
          <SelectedTagPromotionComponent
            value={controller.selectedTagPromotion}
            onChange={controller.handleSelectTagPromotion}
            tagPromotionData={controller?.filterTagPromotionByType}
            disabled={!selectedData ? selectedData : true}
          />
          <TextField
            fullWidth size="small" margin="normal" label={t('promotion_page.Promotion name')}
            InputLabelProps={{ shrink: true }}
            inputRef={controller.promotionName}
            disabled={!selectedData ? selectedData : true}
            sx={{'& .MuiOutlinedInput-root': {borderRadius: '8px' }}}
          />
          <TextField
            fullWidth multiline rows={3} size="small" margin="normal" label={t('promotion_page.Description')}
            InputLabelProps={{ shrink: true }}
            inputRef={controller.description}
            disabled={!selectedData ? selectedData : true}
            sx={{'& .MuiOutlinedInput-root': {borderRadius: '8px' }}}
          />

          {/* Flash Sale */}
          <Box sx={{ display: 'flex', alignItems: 'center', ml: 1 }}>
            <SwitchComponent value={controller.isFlashSale} onChange={controller.handleSelectFlashSale} />
            <Typography fontWeight="bold" color={TEXT_TITLE_COLOR}>{t('promotion_page.Used Flash Sale')}</Typography>
          </Box>

          {/* Flash Sale date */}
          <Box sx={{ mb: 2, mt: 2 }}>
            <DateHourPicker
              disabled={!selectedData ? selectedData : true}
              label={t('promotion_page.Start Date')}
              date={controller.flashSaleStartDate}
              selectedHour={controller.selectedFlashSaleStartDateHour}
              onChangeHour={controller.handleSelectedFlashSaleStartDateHour}
            />
          </Box>
          <DateHourPicker
            disabled={!selectedData ? selectedData : true}
            label={t('promotion_page.End Date')}
            date={controller.flashSaleEndDate}
            selectedHour={controller.selectedFlashSaleEndDateHour}
            onChangeHour={controller.handleSelectedFlashSaleEndDateHour}
          />
        </Grid>

        {/* Grid 2 */}
        <Grid item xs={4} sm={4} md={4}>
          <SelectBranchComponent
            branchValue={controller.selectBranchDataValue}
            onSelectBranch={controller.handleSelectedBranch}
            branchData={branchData}
            disabled={!selectedData ? selectedData : true}
            role={controller.roleAdmin}
          />

          {/* Date Promotion */}
          <Box sx={{ mb: 2, mt: 2 }}>
            <DateHourPicker
              disabled={!selectedData ? selectedData : true}
              label={t('promotion_page.Start Date')}
              date={controller.startDate}
              selectedHour={controller.selectedStartDateHour}
              onChangeHour={controller.handleSelectedStartDateHour}
            />
          </Box>
          <DateHourPicker
            disabled={!selectedData ? selectedData : true}
            label={t('promotion_page.End Date')}
            date={controller.endDate}
            selectedHour={controller.selectedEndDateHour}
            onChangeHour={controller.handleSelectedEndDateHour}
          />

          {selectedData && (
            <>
              {selectedData?.buyProduct.map((item) => (
                <Box key={item?.productId}
                  sx={{ display: 'flex', justifyContent: 'center', mt: 1, flexDirection: 'column'}} >
                  <Typography sx={{ color: '#919EAB' }}>{t('promotion_page.Item code product')} : {item?.itemcode}</Typography>
                  <Typography sx={{ color: '#919EAB' }}>{t('promotion_page.price')} : {item?.price} {t('promotion_page.kip')}</Typography>
                  <Typography sx={{ color: '#919EAB' }}>{t('promotion_page.Buy Product')} :{' '}{i18n.language === EN_ACCEPT_LANGUAGE ? item.productNameEn : item.productNameLa}</Typography>
                  <img src={IMAGE_PRODUCTS_ROOT_URL + item?.image?.url} alt="" style={{ width: 100, height: 100 }} />
                </Box>
              ))}
            </>
          )}

          {/* Date Promotion */}
          {!selectedData && (
            <SearchProductField
              itemCodeRef={controller.itemCodeX}
              titleTextField={t('promotion_page.Input Item Code X')}
              onSearchProduct={controller.handleGetProductX}
            />
          )}

          <SelectProductComponents
            productData={controller.getDataProduct}
            value={controller.selectedProductValue}
            onSelectedProduct={controller.handleSelectedProduct}
          />
          {controller?.getDataProduct?.length === 0 ? (
            <Box sx={{ mb: 1 }}>
              {/* <Typography color='error'>{controller.errorMessageX}</Typography> */}
            </Box>
          ) : (
            <Box>
              <Button onClick={controller.handleGetProductBySelect} variant="contained" sx={{ textTransform: 'none', display: 'flex', justifyContent: 'end' }}>
                {t('promotion_page.Select')}
              </Button>
            </Box>
          )}
          <ListSelectProductComponent
            dataProductBySelect={controller.dataProductBySelect}
            handleDeleteProduct={controller.handleDeleteProduct}
          />
        </Grid>

        {/* Grid 3 */}
        <Grid item xs={4} sm={4} md={4}>
          <FormControl sx={{ mt: 1 }}>
            <RadioGroup row aria-labelledby="demo-row-radio-buttons-group-label" name="row-radio-buttons-group"
              value={controller.selectedPromotionPerDay}
              onChange={controller.handleSelectPromotionPerDay}
            >
              <FormControlLabel
                value={PromotionTypeEnumPromotion.PROMOTION}
                control={<Radio color="secondary" />}
                label={t('promotion_page.Promotion')}
                disabled={!selectedData ? selectedData : true}
              />
              <FormControlLabel
                value={PromotionTypeEnumPromotion.PER_DAY}
                control={<Radio color="secondary" />}
                label={t('promotion_page.per day')}
                disabled={!selectedData ? selectedData : true}
              />
            </RadioGroup>
          </FormControl>
          <Grid container spacing={2}>
            <Grid item xs={6} sm={6} md={6}>
              <TextField
                fullWidth size="small" margin="normal" label={t('promotion_page.limit promotion')}
                InputLabelProps={{ shrink: true }}
                inputRef={controller.limitUse}
                disabled={!selectedData ? selectedData : true}
                sx={{ '& .MuiOutlinedInput-root': {borderRadius: '8px' }}}
              />
              {selectedData && (
                <Typography sx={{ fontSize: '12px', color: '#919EAB' }}>{t('promotion_page.Amount Of Used')} : {selectedData?.amountOfUsed ?? 0}</Typography>
              )}
              <TextField
                fullWidth size="small" margin="normal" label={t('promotion_page.using per user')}
                InputLabelProps={{ shrink: true }}
                inputRef={controller.limitUseOfCustomer}
                disabled={!selectedData ? selectedData : true}
                sx={{ '& .MuiOutlinedInput-root': {borderRadius: '8px' }}}
              />
              <TextField
                fullWidth size="small" margin="normal" label={t('promotion_page.Buy By Price')}
                InputLabelProps={{ shrink: true }}
                inputRef={controller.buyByPrice}
                disabled={!selectedData ? selectedData : true}
                sx={{ '& .MuiOutlinedInput-root': {borderRadius: '8px' }}}
              />
              <TextField
                fullWidth size="small" margin="normal" label={t('promotion_page.Get Point')}
                InputLabelProps={{ shrink: true }}
                inputRef={controller.getPoint}
                disabled={!selectedData ? selectedData : true}
                sx={{ '& .MuiOutlinedInput-root': {borderRadius: '8px' }}}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={6}>
              <TextField
                fullWidth size="small" margin="normal" label={t('promotion_page.Limit Promotion Per Day')}
                disabled={!selectedData ? controller.selectedPromotionPerDay !== 'per_day' : true}
                inputRef={controller.limitProPerDay}
                InputLabelProps={{ shrink: true }}
                sx={{ '& .MuiOutlinedInput-root': {borderRadius: '8px' }}}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {controller.errorMessage && <Typography color="error">{controller.errorMessage}</Typography>}
      <Box mt={2} mb={2}><Divider /></Box>
      <Box sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center', gap: 3 }}>
        <Button onClick={() => onClose()} color="error" variant="contained" sx={{ textTransform: 'none', color: '#fff', width: 200 }}>
          {t('promotion_page.Cancel')}
        </Button>
        {!selectedData && (
          <Button onClick={(e) => controller.handleSubmitForm()} variant="contained" color="secondary" sx={{ textTransform: 'none', color: '#fff', width: 200 }} >
            {t('promotion_page.Create Promotion')}
          </Button>
        )}
      </Box>
      <ConfirmDialog
        open={controller.openConfirmForm}
        title={t('promotion_page.Do you want to create this promotion')}
        loading={controller.loadingButton}
        onCancel={controller.handleCloseConfirmFom}
        onConfirm={() => controller.handleCreatePromotion()}
      />
    </Box>
  );
};

export default BuyXGetSetAGetCSTByPriceFormComponent;
